<div id="layoutSidenav">
    <div id="layoutSidenav_content">
        <main>

            <div class="container-fluid px-5 pt-5 mt-4">
                <!-- Total Leads Section -->
                <!-- Coupon Banner -->


                <h2 class="mb-4">CRM</h2>
                <!-- <div style="float: right;">
                    <button type="button" class="btn btn-primary">Add Lead</button>
                </div> -->
                <ng-container *ngIf="type === 'franchise' || type === 'subfranchise'">
                    Staff:
                    <select name="staff" (change)="selectStaff($event)">
                        <option value="0">Select Value</option>
                        <option *ngFor="let staff of allStaffRecords; let i = index" [value]="staff.franchiseId">
                            {{ staff.personalDetails.firstName }}
                        </option>
                    </select>
                </ng-container>&nbsp;<br />
                <div class="leads-btns">
                    <!-- <button class="btn btn-outline-light me-2"
                            (click)="typeServices(this.lookupModel.getLoggedUser().type,'realEstate')">Real Estate
                            (0)</button>
                        <button class="btn btn-outline-light me-2"
                            (click)="typeServices(this.lookupModel.getLoggedUser().type,'finTech')">FinTech (0)</button>
                        <button class="btn btn-outline-light me-2"
                            (click)="typeServices(this.lookupModel.getLoggedUser().type,'propService')">Prop Services
                            (0)</button> -->
                    <button class="btn me-2" [ngClass]="{
                                'btn-gold': selectedServiceType === 'realEstate',
                                'btn-outline-light': selectedServiceType !== 'realEstate'
                              }" (click)="selectService('realEstate')">
                        Real Estate
                    </button>

                    <button class="btn me-2" [ngClass]="{
                                'btn-gold': selectedServiceType === 'finTech',
                                'btn-outline-light': selectedServiceType !== 'finTech'
                              }" (click)="selectService('finTech')">
                        FinTech
                    </button>

                    <button class="btn me-2" [ngClass]="{
                                'btn-gold': selectedServiceType === 'propService',
                                'btn-outline-light': selectedServiceType !== 'propService'
                              }" (click)="selectService('propService')">
                        Prop Services
                    </button>




                </div>




                <!-- Data Table -->
                <div class="table-responsive thtdfix">
                    <table class="table table-hover">
                        <thead class="table-primary">
                            <tr>
                                <th>S.No</th>
                                <th>Lead ID</th>
                                <th>Category</th>
                                <th>Lead Type</th>
                                <th>Customer Name</th>
                                <th>Mobile Number</th>
                                <th>Email ID</th>
                                <th>Product</th>
                                <th>Product Value</th>
                                <th>Remarks</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let leadRec of leads; let i = index">
                                <td>{{ i + 1 }}</td>
                                <td>{{ leadRec?.leadId }}</td>
                                <td><span [ngClass]="getCategoryClass(leadRec?.category || leadRec?.serviceType )">{{
                                        leadRec?.categoryName || leadRec?.serviceType }}</span></td>
                                <td><span [ngClass]="getLeadTypeClass(leadRec?.leadType)">{{leadRec?.leadType}}</span>
                                </td>
                                <td>{{leadRec?.customerName}}</td>
                                <td>{{ leadRec?.mobile }}</td>
                                <td>{{ leadRec?.email }}</td>
                                <td><span [ngClass]="getProductClass(leadRec?.product)">{{ leadRec?.product}}</span>
                                </td>
                                <td>{{ leadRec?.productValue}}</td>
                                <td><span [title]="leadRec?.remarks" style="cursor: pointer;"
                                        [ngClass]="getStatusClass(leadRec?.remarks)">
                                        {{ leadRec?.remarks?.length > 20 ? (leadRec?.remarks | slice:0:20) + '...' :
                                        leadRec?.remarks || 'Interested Lead' }}
                                    </span></td>
                                <td>
                                    <button class="btn btn-sm btn-outline-primary me-2" (click)="view(leadRec)">
                                        <i class="fa-solid fa-pen-to-square"></i>
                                    </button>
                                    <!-- Add any action buttons here -->
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            </div>
        </main>

    </div>
</div>